
import React from 'react'
import './index.less'
console.log(React)
export default function TopImage(props) {
  return (<div className={`topImage ${props.selectItem ? props.selectItem.id === props.compIfon.id ? 'active' : '' : ''}`} style={{
    height: 'auto'
  }}>
    {props.ifon.imageList.length

      ? <div className='topImage_ifon'>
        {props.ifon.imageList.map((itme, index) => {
          return (
            <div
              className={`ifon_img ${props.ifon.currentIndex === index ? 'active' : ''}`}
              key={itme.id}
              style={{
                width: itme.fileIfon.width,
                minHeight: itme.fileIfon.height,
                paddingTop: itme.fileIfon.paddingTop,
                paddingBottom: itme.fileIfon.paddingBottom,
                paddingLeft: itme.fileIfon.paddingLeft,
                paddingRight: itme.fileIfon.paddingRight
              }}>
              <img className='img' style={{ height: itme.fileIfon.height }} src={itme.fileIfon.src} />
              {itme.isHotZone && itme.hotZoneQuantity.map((item1, index1) => {
                return (<span
                  key={item1.id}
                  style={{
                    width: itme.hotZone[index1].width,
                    height: itme.hotZone[index1].height,
                    top: itme.hotZone[index1].y,
                    left: itme.hotZone[index1].x
                  }}
                  className='hotspot'
                  onMouseDown={(e) => {
                    drag(e, props, index1, index)
                  }} onMouseMove={move} onClick={(e) => {
                    e.stopPropagation()
                  }}></span>)
              })}
            </div>
          )
        })}
      </div>

      : <div className='topImage_seizeASeat'>
        <img className='seizeASeat_image' src='https://read.e.qq.com/assets/images/yuebao/icon_upload_back.png' />
      </div>}
  </div>)
}

function drag(e, props, index, Index) {
  e.stopPropagation()

  if (props.selectItem && (props.ifon.currentIndex !== Index || props.compIfon.id !== props.selectItem.id)) {
    return
  }

  const parentIfon = e.target.parentNode.getBoundingClientRect()
  const ownIfon = e.target.getBoundingClientRect()
  const X = parentIfon.width - ownIfon.width
  const Y = parentIfon.height - ownIfon.height
  const pressX = e.clientX
  const pressY = e.clientY
  const initialX = parseFloat(getComputedStyle(e.target).left)
  const initialY = parseFloat(getComputedStyle(e.target).top)
  const widthl = ownIfon.width
  const height = ownIfon.height
  const top = parseFloat(getComputedStyle(e.target).top)
  const left = parseFloat(getComputedStyle(e.target).left)

  const tagM = getComputedStyle(e.target).cursor

  const pressTa = e.target

  e.target.onmousemove = (e) => {
    if (tagM === 'pointer') {
      // const ownIfon = e.target.getBoundingClientRect()

      let x = e.clientX - pressX + initialX
      let y = e.clientY - pressY + initialY

      if (x >= X) {
        x = X
      }

      if (x <= 0) {
        x = 0
      }

      if (y >= Y) {
        y = Y
      }

      if (y <= 0) {
        y = 0
      }

      e.target.style.left = x + 'px'
      e.target.style.top = y + 'px'
    } else {
      if (tagM === 'ne-resize' || tagM === 'se-resize' || tagM === 'nw-resize' || tagM === 'sw-resize') {
        if (tagM === 'ne-resize') {
          const width1 = e.clientX - pressX
          const height1 = pressY - e.clientY

          let Top = top + 'px'
          let Width = widthl + width1 + 'px'
          let Height = height + height1 + 'px'

          if (height1 > 0) {
            Top = top + (e.clientY - pressY) + 'px'
          }

          if (height1 >= top) {
            Top = 0
            Height = height + top + 'px'
          }

          if (width1 >= parentIfon.width - (left + widthl)) {
            Width = parentIfon.width - left + 'px'
          }

          if (height1 < 0) {
            Top = top - (pressY - e.clientY) + 'px'
          }

          e.target.style.top = Top
          e.target.style.width = Width
          e.target.style.height = Height
        } else if (tagM === 'se-resize') {
          const width1 = e.clientX - pressX
          const height1 = e.clientY - pressY

          let Height = height + height1 + 'px'
          let Width = widthl + width1 + 'px'

          if ((height + height1) >= (parentIfon.height - top)) {
            Height = parentIfon.height - top + 'px'
          }
          if ((widthl + width1) >= (parentIfon.width - left)) {
            Width = parentIfon.width - left + 'px'
          }

          e.target.style.width = Width
          e.target.style.height = Height
        } else if (tagM === 'nw-resize') {
          const width1 = pressX - e.clientX
          const height1 = pressY - e.clientY
          let Top = top + 'px'
          let Left = left + 'px'
          let Width = widthl + width1 + 'px'
          let Height = height + height1 + 'px'

          if (height1 > 0) {
            Height = height + height1 + 'px'
            Top = top + (e.clientY - pressY) + 'px'
          }
          if (height1 >= top) {
            Height = height + top + 'px'
            Top = 0
          }
          if (height1 < 0) {
            Height = height - (e.clientY - pressY) + 'px'
            Top = top + (e.clientY - pressY) + 'px'
          }
          if (width1 > 0) {
            Width = widthl + width1 + 'px'
            Left = left + (e.clientX - pressX) + 'px'
          }
          if (width1 >= left) {
            Width = widthl + left + 'px'
            Left = 0
          }
          if (width1 < 0) {
            Width = widthl - (e.clientX - pressX) + 'px'
            Left = left + (e.clientX - pressX) + 'px'
          }

          e.target.style.width = Width
          e.target.style.left = Left
          e.target.style.height = Height
          e.target.style.top = Top
        } else if (tagM === 'sw-resize') {
          const width1 = pressX - e.clientX
          const height1 = e.clientY - pressY
          let Left = left + 'px'
          let Width = widthl + width1 + 'px'
          let Height = height + height1 + 'px'
          if (width1 > 0) {
            Left = left - (pressX - e.clientX) + 'px'
          }
          if (width1 < 0) {
            Left = left + (e.clientX - pressX) + 'px'
          }
          if (width1 >= left) {
            Width = widthl + left + 'px'
            Left = 0
          }
          if (height1 >= (parentIfon.height - (top + height))) {
            Height = parentIfon.height - top + 'px'
          }
          e.target.style.width = Width
          e.target.style.height = Height
          e.target.style.left = Left
        }
      } else if (tagM === 'n-resize') {
        const ownIfon = e.target.getBoundingClientRect()
        const op = e.clientY < (ownIfon.y + (ownIfon.height / 2)) ? '上' : '下'
        if (op === '上') {
          const height1 = pressY - e.clientY
          let Top = top + 'px'
          let Height = height + height1 + 'px'
          if (height1 > 0) {
            Top = top - (pressY - e.clientY) + 'px'
          }
          if (height1 < 0) {
            Top = top + (e.clientY - pressY) + 'px'
          }
          if (height1 >= top) {
            Height = height + top + 'px'
            Top = 0
          }
          e.target.style.top = Top
          e.target.style.height = Height
        } else {
          const height1 = e.clientY - pressY
          let Height = height1 + height + 'px'
          if (height1 >= (parentIfon.height - (top + height))) {
            Height = (parentIfon.height - top) + 'px'
          }
          e.target.style.height = Height
        }
      } else if (tagM === 'e-resize') {
        const ownIfon = e.target.getBoundingClientRect()
        const op = e.clientX < (ownIfon.x + (ownIfon.width / 2)) ? '左' : '右'
        if (op === '左') {
          const width1 = pressX - e.clientX
          let Wdith = widthl + width1 + 'px'
          let Left = left + 'px'
          if (width1 > 0) {
            Left = left - width1 + 'px'
          }
          if (width1 < 0) {
            Left = left - width1 + 'px'
          }
          if (width1 >= left) {
            Wdith = widthl + left + 'px'
            Left = 0
          }
          e.target.style.width = Wdith
          e.target.style.left = Left
        } else {
          const width1 = e.clientX - pressX
          let Width = widthl + width1 + 'px'
          if (width1 >= (parentIfon.width - (left + widthl))) {
            Width = parentIfon.width - left + 'px'
          }
          e.target.style.width = Width
        }
      }
    }
  }

  const func = (e) => {
    e.stopPropagation()

    window.removeEventListener('mouseup', func)
    e.target.onmousemove = null
    pressTa.onmousemove = null
    if (tagM) {
      const ifon = e.target.parentNode.getBoundingClientRect()
      const currentIndex = props.ifon.currentIndex
      const style = getComputedStyle(e.target.nodeName !== 'SPAN' ? pressTa : e.target)
      const cwidth = parseFloat(style.width)
      const height = parseFloat(style.height)
      const top = parseFloat(style.top)
      const left = parseFloat(style.left)

      const Width = 375 - left
      const Height = ifon.height - top
      const X = 375 - cwidth
      const Y = ifon.height - height

      const obj = {
        width: cwidth,
        height,
        x: left,
        y: top,
        Width,
        Height,
        X,
        Y
      }

      props.ifon.imageList[currentIndex].hotZone[index] = {
        ...props.ifon.imageList[currentIndex].hotZone[index],
        ...obj
      }

      props.mySetIfon(props.ifon)
    }
  }

  window.addEventListener('mouseup', func)
}

function move(e) {
  const ownIfon = e.target.getBoundingClientRect()
  let value = 'pointer'
  const X = ownIfon.x + ownIfon.width
  const Y = ownIfon.y + ownIfon.height
  const x = ownIfon.x
  const y = ownIfon.y

  if ((e.clientX < X && e.clientX > (X - 10)) && (e.clientY > y) && e.clientY < (y + 10)) {
    value = 'ne-resize'
  } else if (e.clientY < Y && e.clientY > (Y - 10) && (e.clientX > (X - 10)) && e.clientX < X) {
    value = 'se-resize'
  } else if (e.clientX > x && e.clientX < (x + 10) && (e.clientY < (y + 10)) && e.clientY > y) {
    value = 'nw-resize'
  } else if (e.clientY < Y && e.clientY > (Y - 10) && (e.clientX < (x + 10)) && e.clientX > x) {
    value = 'sw-resize'
  } else if ((e.clientY > y && e.clientY < (y + 10)) || (e.clientY < Y && e.clientY > (Y - 10))) {
    value = 'n-resize'
  } else if ((e.clientX > x && e.clientX < (x + 10)) || (e.clientX < X && e.clientX > (X - 10))) {
    value = 'e-resize'
  }

  e.target.style.cursor = value
}
